export default "__VITE_ASSET__C5VTw6RE__"